var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircleOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_230_84791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4153 14.3967L18.3337 26.4784L11.752 19.9151L9.16699 22.5001L18.3337 31.6667L33.0003 17.0001L30.4153 14.3967ZM22.0003 4.16675C11.8803 4.16675 3.66699 12.3801 3.66699 22.5001C3.66699 32.6201 11.8803 40.8334 22.0003 40.8334C32.1203 40.8334 40.3337 32.6201 40.3337 22.5001C40.3337 12.3801 32.1203 4.16675 22.0003 4.16675ZM22.0003 37.1667C13.897 37.1667 7.33366 30.6034 7.33366 22.5001C7.33366 14.3967 13.897 7.83341 22.0003 7.83341C30.1037 7.83341 36.667 14.3967 36.667 22.5001C36.667 30.6034 30.1037 37.1667 22.0003 37.1667Z",
    fill: "#307FE2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_230_84791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleOutline);
export default __webpack_public_path__ + "static/media/check_circle_outline.0dff8f1bcb03427c5b16e63d6709af1e.svg";
export { ForwardRef as ReactComponent };